export default __webpack_public_path__ + "static/media/mac_trade.b2140f1a.png";